import { render, staticRenderFns } from "./CampaignStatusButton.vue?vue&type=template&id=13bf0890&scoped=true"
import script from "./CampaignStatusButton.vue?vue&type=script&lang=js"
export * from "./CampaignStatusButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf0890",
  null
  
)

export default component.exports